import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import * as styles from './OptionInputFields.module.scss'

import {
  OptionInputFieldResponse,
  OptionInputFieldResponseFieldTypeEnum,
} from '../../../apis/fvillage/api'
import { getPublication } from '../../../hooks'
import { OptionItem } from '../../../schemas'
import { getOptionInputFieldLabel } from '../../../utils'
import { ErrorMessage, FormInput, FormSelect, Option } from '../../basics'

type OptionInputFieldsProps = {
  index: number
  inputFields: OptionInputFieldResponse[]
}

const translateNamespace = 'components.OptionInputFields'

export const OptionInputFields: React.FC<OptionInputFieldsProps> = ({
  index,
  inputFields,
}) => {
  const { t, i18n } = useTranslation()
  const {
    control,
    formState: { errors },
  } = useFormContext<OptionItem>()

  return (
    <div className={styles.fields}>
      {inputFields.map((inputField, answerIndex) => {
        const name = `items.${index}.answers.${answerIndex}.value` as const
        const label = getOptionInputFieldLabel(i18n.language, inputField)
        return (
          <div key={inputField.id}>
            {inputField.fieldType ===
            OptionInputFieldResponseFieldTypeEnum.Select ? (
              <FormSelect
                name={name}
                control={control}
                label={label}
                required={inputField.isRequired}
              >
                <Option value="">
                  {t(`${translateNamespace}.placeholder`)}
                </Option>
                {inputField.choices.map((choice) => (
                  <Option key={choice.key} value={choice.key}>
                    {getPublication(i18n.language, choice.labels)?.label ??
                      choice.key}
                  </Option>
                ))}
              </FormSelect>
            ) : (
              <FormInput
                name={name}
                control={control}
                label={label}
                required={inputField.isRequired}
                maxLength={255}
                inputMode={
                  inputField.fieldType ===
                  OptionInputFieldResponseFieldTypeEnum.Number
                    ? 'numeric'
                    : undefined
                }
              />
            )}
            <ErrorMessage
              errors={errors}
              name={name}
              message={
                errors?.items?.[index]?.answers?.[answerIndex]?.value
                  ?.message ?? ''
              }
            />
          </div>
        )
      })}
    </div>
  )
}
